import { styled, Typography } from '@mui/material';
import { AccessTypeT } from 'business/definitions';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Flex from 'ui/Flex/Flex';
import AccessTypeButton from '../ui/AccessTypeButton';

const StyPermissionEditorWrapper = styled(Flex)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    gap: theme.spacing(2),
}));

export type AccessTypeButtonItem = {
    type: AccessTypeT;
    tooltipTitle?: string;
    hidden?: boolean;
};

interface PermissionEditorProps {
    title: string;
    titleAction?: React.ReactNode;
    accessType: AccessTypeT;
    accessTypeButtons: AccessTypeButtonItem[];
    updateAccessType: (arg1: AccessTypeT) => void;
}

const PermissionEditor = ({
    title,
    titleAction = <></>,
    children,
    accessType,
    accessTypeButtons,
    updateAccessType,
}: React.PropsWithChildren<PermissionEditorProps>) => {
    const { t } = useTranslation();

    const isRestricted = accessType === 'restricted';
    return (
        <StyPermissionEditorWrapper>
            <Flex flex={1} alignItems="center" justifyContent="space-between">
                <Typography variant="body1Bold" color="primary">
                    {title}
                </Typography>
                {titleAction}
            </Flex>
            <Flex flex={1} alignItems="center" gap={2}>
                {accessTypeButtons.map((accessTypeButton) => {
                    const {
                        type: buttonType,
                        tooltipTitle,
                        hidden,
                    } = accessTypeButton;
                    if (hidden) {
                        return <></>;
                    }
                    return (
                        <AccessTypeButton
                            type={buttonType}
                            selected={accessType === buttonType}
                            onClick={() => {
                                updateAccessType(buttonType);
                            }}
                            tooltipTitle={tooltipTitle && t(tooltipTitle)}
                            key={accessTypeButton.type}
                        />
                    );
                })}
            </Flex>
            {isRestricted && children}
        </StyPermissionEditorWrapper>
    );
};

export default PermissionEditor;
